import type { QueryClient } from '@tanstack/react-query';
import type { ResearchConfigurationLiteItem } from '@types';
import { sessionLiteQueryOptions } from './sessionLiteQueryOptions';

export const prefetchSessionLiteMetadata = async (
  queryClient: QueryClient,
  userId: string,
  sessionIds: number[],
  options?: { force?: boolean }
): Promise<Map<number, ResearchConfigurationLiteItem>> => {
  const uniqueIds = [...new Set(sessionIds)];
  const result = new Map<number, ResearchConfigurationLiteItem>();

  await Promise.all(
    uniqueIds.map(async sessionId => {
      const item = await queryClient.fetchQuery({
        ...sessionLiteQueryOptions(userId, sessionId),
        ...(options?.force ? { staleTime: 0 } : {}),
      });

      if (item) {
        result.set(sessionId, item);
      }
    })
  );

  return result;
};
